export default __webpack_public_path__ + "static/media/right2_hover.8c81871f.svg";